import { Enum } from "@/commons/enums/Type";

export class BrowserEnum {
  static BAIDU_SPIDER = { value: 1, text: "Baiduspider" };
  static BING_PREVIEW = { value: 2, text: "BingPreview" };
  static CHROME = { value: 3, text: "Chrome" };
  static EDGE = { value: 4, text: "Edge" };
  static FACEBOOK = { value: 5, text: "facebook" };
  static FIREFOX = { value: 6, text: "Firefox" };
  static GOOGLE_APP_ENGINE = { value: 7, text: "Google AppEngine" };
  static GOOGLE_SEARCH_APP = { value: 8, text: "Google Search App" };
  static GOOGLE_WEB_PREVIEW = { value: 9, text: "Google Web Preview" };
  static GOOGLE_BOT = { value: 10, text: "Googlebot" };
  static IE = { value: 11, text: "Internet Explorer" };
  static MISC_CRAWLER = { value: 12, text: "misc crawler" };
  static OPERA = { value: 13, text: "Opera" };
  static SAFARI = { value: 14, text: "Safari" };
  static UNKNOWN = { value: 15, text: "UNKNOWN" };
  static VIVALDI = { value: 16, text: "Vivaldi" };
  static WEBVIEW = { value: 17, text: "Webview" };
  static XBOX_ONE = { value: 18, text: "Xbox One" };
  static YANDEX_BROWSER = { value: 19, text: "Yandex Browser" };

  static getByValue(value: number): Enum | undefined {
    if (value === BrowserEnum.BAIDU_SPIDER.value) {
      return BrowserEnum.BAIDU_SPIDER;
    }
    if (value === BrowserEnum.BING_PREVIEW.value) {
      return BrowserEnum.BING_PREVIEW;
    }
    if (value === BrowserEnum.CHROME.value) {
      return BrowserEnum.CHROME;
    }
    if (value === BrowserEnum.EDGE.value) {
      return BrowserEnum.EDGE;
    }
    if (value === BrowserEnum.FACEBOOK.value) {
      return BrowserEnum.FACEBOOK;
    }
    if (value === BrowserEnum.FIREFOX.value) {
      return BrowserEnum.FIREFOX;
    }
    if (value === BrowserEnum.GOOGLE_APP_ENGINE.value) {
      return BrowserEnum.GOOGLE_APP_ENGINE;
    }
    if (value === BrowserEnum.GOOGLE_SEARCH_APP.value) {
      return BrowserEnum.GOOGLE_SEARCH_APP;
    }
    if (value === BrowserEnum.GOOGLE_WEB_PREVIEW.value) {
      return BrowserEnum.GOOGLE_WEB_PREVIEW;
    }
    if (value === BrowserEnum.GOOGLE_BOT.value) {
      return BrowserEnum.GOOGLE_BOT;
    }
    if (value === BrowserEnum.IE.value) {
      return BrowserEnum.IE;
    }
    if (value === BrowserEnum.MISC_CRAWLER.value) {
      return BrowserEnum.MISC_CRAWLER;
    }
    if (value === BrowserEnum.OPERA.value) {
      return BrowserEnum.OPERA;
    }
    if (value === BrowserEnum.SAFARI.value) {
      return BrowserEnum.SAFARI;
    }
    if (value === BrowserEnum.UNKNOWN.value) {
      return BrowserEnum.UNKNOWN;
    }
    if (value === BrowserEnum.VIVALDI.value) {
      return BrowserEnum.VIVALDI;
    }
    if (value === BrowserEnum.WEBVIEW.value) {
      return BrowserEnum.WEBVIEW;
    }
    if (value === BrowserEnum.XBOX_ONE.value) {
      return BrowserEnum.XBOX_ONE;
    }
    if (value === BrowserEnum.YANDEX_BROWSER.value) {
      return BrowserEnum.YANDEX_BROWSER;
    }
    return undefined;
  }

  static getList(): Enum[] {
    return [
      BrowserEnum.BAIDU_SPIDER,
      BrowserEnum.BING_PREVIEW,
      BrowserEnum.CHROME,
      BrowserEnum.EDGE,
      BrowserEnum.FACEBOOK,
      BrowserEnum.FIREFOX,
      BrowserEnum.GOOGLE_APP_ENGINE,
      BrowserEnum.GOOGLE_SEARCH_APP,
      BrowserEnum.GOOGLE_WEB_PREVIEW,
      BrowserEnum.GOOGLE_BOT,
      BrowserEnum.IE,
      BrowserEnum.MISC_CRAWLER,
      BrowserEnum.OPERA,
      BrowserEnum.SAFARI,
      BrowserEnum.UNKNOWN,
      BrowserEnum.VIVALDI,
      BrowserEnum.WEBVIEW,
      BrowserEnum.XBOX_ONE,
      BrowserEnum.YANDEX_BROWSER,
    ];
  }
}
